import { http } from "@/src/service/flow/FlowFrontendService";

async function getNotificaton(refType: string, refId: string) {
  return await http<any>("GET", `/v1/notification/ref/${refType}/${refId}`);
}

export default { getNotificaton };
